import useDomain from "hooks/useDomain";

const useLogout = () => {
  const { run } = useDomain();

  const logout = async () => {
    caches?.keys?.()?.then((names) => {
      for (const name of names) {
        caches.delete(name);
      }
    });

    run((domain: any) => domain.logout_use_case.execute());
  };

  return {
    logout,
  };
};

export default useLogout;
